module.exports = __webpack_public_path__ + "img/product-placeholder-83.fb5bd2e.png";